import { PomodoroTimerComponent } from './pages/pomodoro-timer/pomodoro-timer.component';
import { NgModule, effect, inject, isDevMode, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { UiModule } from './ui/ui.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ButtonModule, ConfirmService, HasRoleDirective, ModalService, ProgressBarComponent, ToastModule, ToastService } from '@atsystems/ui';
import { ErrorInterceptor } from './common/helpers/errors.interceptor';
import { AppUpdateService } from './app-update.service';
import { IconService } from './common/services/icon.service';
import { NetworkStatusService } from './common/services/network-status.service';
import { ServiceWorkerModule } from '@angular/service-worker';
import { provideRouter, withComponentInputBinding, withRouterConfig } from '@angular/router';
import { routes } from './app-routing.module';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { monacoConfig } from './common/helpers/monaco';
import { BottomContextMenuService } from './ui/modules/bottom-context-menu/bottom-context-menu.service';
import { SelectionService } from './ui/services/selection.service';
import { provideKeycloakAngular, urlCondition } from './common/helpers/keycloak-init.factory';
import { INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG, includeBearerTokenInterceptor, KEYCLOAK_EVENT_SIGNAL, KeycloakEventType } from 'keycloak-angular';
import { CurrencyPipe, DecimalPipe, PercentPipe } from '@angular/common';
import { SpotlightService } from './ui/modules/spotlight/spotlight.service';
import { NotifierApiInterceptor } from './common/helpers/notifier-api.interceptor';
import { sandboxInterceptor } from './common/helpers/sandbox.interceptor';
import { ConfigService } from './common/services/config.service';

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    UiModule,
    ToastModule,
    HasRoleDirective,
    ProgressBarComponent,
    PomodoroTimerComponent,
    MonacoEditorModule.forRoot(monacoConfig),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: NotifierApiInterceptor, multi: true },
    //{ provide: HTTP_INTERCEPTORS, useClass: OfflineInterceptor, multi: true},
    //{ provide: ErrorHandler, useClass: GlobalErrorHandler },
    ToastService,
    ConfirmService,
    AppUpdateService,
    ModalService,
    SpotlightService,
    IconService,
    ButtonModule,
    NetworkStatusService,
    BottomContextMenuService,
    SelectionService,
    provideHttpClient(withInterceptorsFromDi(), withInterceptors([includeBearerTokenInterceptor, sandboxInterceptor])),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withRouterConfig({
        paramsInheritanceStrategy: 'always',
      })
    ),
    provideKeycloakAngular(),
    provideAppInitializer(() => {
      const keycloakSignal = inject(KEYCLOAK_EVENT_SIGNAL);
      const config = inject(ConfigService);

      return new Promise<void>(resolve => {
        effect(() => {
          const event = keycloakSignal();
          if (event.type === KeycloakEventType.Ready) {
            config.initialize().then(() => resolve());
          }
        });
      });
    }),
    {
      provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
      useValue: [urlCondition],
    },
    CurrencyPipe,
    DecimalPipe,
    PercentPipe,
  ],
})
export class AppModule {}
